const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

export const initUtm = () => {
  const params = new URLSearchParams(window.location.search);
  const fresh = {};
  UTM_KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) fresh[k] = v;
  });
  if (Object.keys(fresh).length) {
    sessionStorage.setItem("tryvitta_utm", JSON.stringify(fresh));
  }
  return getUtm();
};

export const getUtm = () => {
  try {
    return JSON.parse(sessionStorage.getItem("tryvitta_utm")) || {};
  } catch {
    return {};
  }
};

// Contexto de tráfego para destaque contextual (desafio/slim/treino/generico)
export const getUtmContext = () => {
  const u = getUtm();
  const s = `${u.utm_source || ""} ${u.utm_medium || ""} ${u.utm_campaign || ""} ${u.utm_content || ""}`.toLowerCase();
  if (/desafio|mutants|premio/.test(s)) return "desafio";
  if (/slim|emagrec|glp|caneta/.test(s)) return "slim";
  if (/treino|muscula|academia/.test(s)) return "treino";
  return "generico";
};

import { trackMeta, trackMetaCustom, tiktokTrack } from "@/analytics/pixels";

const META_MAP = {
  landing_view: ["track", "ViewContent", {}],
  quiz_started: ["trackCustom", "QuizStarted", {}],
  quiz_completed: ["trackCustom", "QuizCompleted", {}],
  lead_email_captured: ["track", "Lead", { content_name: "email_capture" }],
  app_store_click: ["trackCustom", "AppStoreClick", {}],
  google_play_click: ["trackCustom", "GooglePlayClick", {}],
  plan_cta_clicked: ["trackCustom", "PlanCtaClick", {}],
};

const TIKTOK_MAP = {
  page_view: "ViewContent",
  lead_email_captured: "SubmitForm",
  app_store_click: "ClickButton",
  google_play_click: "ClickButton",
};

const SENSITIVE_KEYS = ["email", "name", "phone", "message"];

const sanitize = (params) =>
  Object.fromEntries(Object.entries(params).filter(([k]) => !SENSITIVE_KEYS.includes(k)));

export const trackEvent = (name, params = {}) => {
  if (typeof window === "undefined") return;
  const payload = { event: name, ...getUtm(), ...params };
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
  if (typeof window.gtag === "function") window.gtag("event", name, payload);

  const safe = sanitize(params);
  const meta = META_MAP[name];
  if (meta) {
    const [method, eventName, defaults] = meta;
    if (method === "track") trackMeta(eventName, { ...defaults, ...safe });
    else trackMetaCustom(eventName, safe);
  }
  const tiktok = TIKTOK_MAP[name];
  if (tiktok) tiktokTrack(tiktok, { ...safe, source_event: name });
};

// Captura UTMs já na importação do módulo (antes do primeiro render)
if (typeof window !== "undefined") initUtm();

// Anexa UTMs aos links das lojas (referrer no Google Play; query na App Store)
export const withUtm = (url) => {
  const utm = getUtm();
  const keys = Object.keys(utm);
  if (!keys.length) return url;
  const qs = keys.map((k) => `${k}=${encodeURIComponent(utm[k])}`).join("&");
  if (url.includes("play.google.com")) {
    return `${url}${url.includes("?") ? "&" : "?"}referrer=${encodeURIComponent(qs)}`;
  }
  return `${url}${url.includes("?") ? "&" : "?"}${qs}`;
};
